






















































































import { Prop, Vue, Emit, Component } from 'vue-property-decorator';
import HoverDescription from '@/components/atoms/HoverDescription.vue';
import { getUrlTarget } from '@/containers/globals/Util';
import {
  MenuListItem,
  ID,
  UpdateFavoriteEvent,
  ClickProductUrlEvent,
  Product,
  MenuIcon,
} from '@/types/type';
import { REL } from '@/utils/consts';

@Component({ components: { HoverDescription } })
export default class GridElement extends Vue {
  private hoveredItemId: string = '';
  private hoverable: boolean = false;
  private open: string[] = [];
  private tree: string[] = [];

  @Prop()
  private menus!: MenuListItem[];

  @Prop()
  private parentMenu!: MenuListItem;

  private getIcon(menu: MenuListItem, open: string[]): string {
    return menu.isCategory
      ? open
        ? 'mdi-folder-open'
        : 'mdi-folder'
      : menu.icon;
  }

  private getTarget(product: Product): string {
    return getUrlTarget(product);
  }

  private getNudgeBottom(isCategory: boolean) {
    return isCategory ? 0 : 18;
  }

  private mouseOver(id: string): void {
    this.hoveredItemId = id;
  }

  private mouseLeave(): void {
    this.hoveredItemId = '';
  }

  @Emit('update-favorite')
  private updateFavorite(id: ID, isFavorite: boolean): UpdateFavoriteEvent {
    return { id, isFavorite };
  }

  @Emit('click-url')
  private clickUrl(menu: MenuListItem): ClickProductUrlEvent {
    const { id, url, product } = menu;
    return { menuId: id, product, url };
  }
}
